import React from "react";
import { BookOpen, Edit2, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";

export const StudiesTab = ({ studies, setIsAddStudyOpen, openStudyEditor, deleteStudy }) => (
  <div className="space-y-6" data-testid="admin-studies-tab">
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Study Management</h2>
        <p className="text-gray-600">Manage clinical research studies</p>
      </div>
      <Button onClick={() => setIsAddStudyOpen(true)} className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700" data-testid="add-study-btn">
        <BookOpen className="h-4 w-4" /> Add New Study
      </Button>
    </div>

    <Card className="border-0 shadow-lg bg-gradient-to-br from-purple-50 to-purple-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-purple-900">Total Studies</CardTitle>
        <BookOpen className="h-4 w-4 text-purple-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-purple-900">{studies.length}</div></CardContent>
    </Card>

    <Card className="border-0 shadow-lg">
      <CardHeader className="bg-gray-50 rounded-t-lg"><CardTitle className="text-gray-900">All Studies</CardTitle></CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left p-4 font-semibold text-gray-700">Study Name</th>
                <th className="text-left p-4 font-semibold text-gray-700">Protocol</th>
                <th className="text-left p-4 font-semibold text-gray-700">Phase</th>
                <th className="text-left p-4 font-semibold text-gray-700">Therapeutic Area</th>
                <th className="text-left p-4 font-semibold text-gray-700">Study Lead</th>
                <th className="text-left p-4 font-semibold text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {studies.map((study, index) => (
                <tr key={study.id} className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`} data-testid={`study-row-${study.id}`}>
                  <td className="p-4 font-medium text-gray-900">{study.name}</td>
                  <td className="p-4 text-gray-600">{study.protocol_number}</td>
                  <td className="p-4"><Badge variant="outline" className="bg-blue-100 text-blue-800">{study.phase}</Badge></td>
                  <td className="p-4 text-gray-600">{study.therapeutic_area}</td>
                  <td className="p-4 text-gray-600">{study.study_lead}</td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <Button size="sm" variant="outline" onClick={() => openStudyEditor(study)} className="hover:bg-purple-50" data-testid={`edit-study-${study.id}`}>
                        <Edit2 className="h-3 w-3" />
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => deleteStudy(study.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" data-testid={`delete-study-${study.id}`}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  </div>
);
